import moment from 'moment'

declare module '#app' {
  interface NuxtApp {
    $moment: typeof moment
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      moment,
    },
  }
})
